import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {getMaxPowerXFlyback, getMinPower} from "./acdc__common_acceptor";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";

export class Acceptor_AcDc_QR_Flyback extends Acceptor_Common {

  private acceptSingle_QR_FLYBACK_Vout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single voltage output is defined and inside the bounds */
    return (!Utils.isValueReal(out.voltage)) || ((a.vout_min <= out.voltage && out.voltage <= a.vout_max));
  }

  private acceptSingle_QR_FLYBACK_Iout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single current output is defined and inside the bounds */
    return (!Utils.isValueReal(out.current)) || ((0 <= out.current && out.current <= a.iout_max));
  }

  private acceptSingle_QR_FLYBACK_Pout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single voltage output is defined and inside the bounds */

    if (Utils.isValueReal(out.voltage) && Utils.isValueReal(out.current)) {
      const singlePower = out.current * out.voltage;

      const minPower: number = getMinPower(a);
      const maxPower: number = getMaxPowerXFlyback(a, spec);
      // console.log("acceptSingle_QR_FLYBACK_Pout", minPower, singlePower, maxPower)
      return ((minPower <= singlePower && singlePower <= maxPower));
    } else {
      return true;
    }
  }

  protected singleOutputV(): AcceptorOutputFn {
    return this.acceptSingle_QR_FLYBACK_Vout;
  }

  protected singleOutputI(): AcceptorOutputFn {
    return this.acceptSingle_QR_FLYBACK_Iout;
  }

  protected singleOutputP(): AcceptorOutputFn {
    return this.acceptSingle_QR_FLYBACK_Pout;
  }
}
